require('./brokerMainStocksResultListContentFilters.scss');
const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @helpers
const { FormattedText } = require('core/i18n').i18n;
// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKModal = require('components/commons/OKModal/OKModal');
const { InputSafe } = require('commonsComponents/inputSafe');

class BrokerMainStocksResultListContentFilters extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
            filters: {
                term: {
                    value: this.props.filters.term.value
                }
            }
        };

        this.buildFiltersBlock = this.buildFiltersBlock.bind(this);
        this.buildFilterTermLabel = this.buildFilterTermLabel.bind(this);
        this.buildModalContent = this.buildModalContent.bind(this);
        this.handleFilterClick = this.handleFilterClick.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleFiltersSubmit = this.handleFiltersSubmit.bind(this);
        this.handleOnChangeInput = this.handleOnChangeInput.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildFilterTermLabel() {
        const { filters } = this.props;
        const filteredTerm = (filters.term.value.length > 50) ? filters.term.value.substr(0, 49) + '...' : filters.term.value;

        if (filters.term && filters.term.isActive) {
            return (
                <div className="broker-main-stocks-result-list-content-filters__state-label">
                    <FormattedText value="broker-indexValuesFiltersTermLabel" />: {filteredTerm}
                </div>
            );
        }
    }

    buildFiltersBlock() {
        const { filters, clearFilters } = this.props;
        const activeFilters = Object.getOwnPropertyNames(filters).find(
            filterName => filters[filterName].isActive
        );
        let allOrClearElement, labelFilter;

        if (activeFilters) {
            const filterTermLabel = this.buildFilterTermLabel();

            allOrClearElement = (
                <span className="broker-main-stocks-result-list-content-filters__label-all">
                    <OKButton
                        modifier="link-complementary"
                        onClick={clearFilters}
                    >
                        <FormattedText value="filters-clear" />
                    </OKButton>
                </span>
            );
            labelFilter = (
                <div className="broker-main-stocks-result-list-content-filters__labels">
                    {filterTermLabel}
                </div>
            );
        } else {
            allOrClearElement = (
                <FormattedText
                    value="filters-all"
                    format="uppercase"
                    className="broker-main-stocks-result-list-content-filters__label-all"
                />
            );
        }

        return (
            <section className="broker-main-stocks-result-list-content-filters__filters">
                <div className="broker-main-stocks-result-list-content-filters__filters-buttons">
                    {allOrClearElement}
                    <OKButton
                        id="btn_filterButton"
                        modifier="task"
                        onClick={this.handleFilterClick}
                    >
                        <i className="icon-filtrar broker-main-stocks-result-list-content-filters__filter-settings-icon" />
                    </OKButton>
                </div>
                {labelFilter}
            </section>
        );
    }

    buildModalContent() {
        const filterValue = this.state.filters.term.value;

        return (
            <section className="broker-main-stocks-result-list-content-filters__modal">
                <form className="form form-horizontal" onSubmit={this.handleFiltersSubmit}>
                    <div className="broker-main-stocks-result-list-content-filters__modal-filter">
                        <label className="broker-main-stocks-result-list-content-filters__modal-filter-label">
                            <FormattedText value="broker-indexValuesFiltersTermLabel" />
                        </label>
                        <InputSafe
                            id="filter-term"
                            type="text"
                            className="form-control"
                            value={filterValue}
                            onChange={this.handleOnChangeInput}
                        />
                    </div>
                </form>
            </section>
        );
    }

    handleCloseModal() {
        this.setState({
            modalOpen: !this.state.modalOpen
        });
    }

    handleFilterClick() {
        this.setState({
            modalOpen: !this.state.modalOpen
        });
    }

    handleFiltersSubmit(event) {
        event.preventDefault();
        const { activateTermFilter } = this.props;
        const { filters } = this.state;

        if (filters.term.value) {
            activateTermFilter(filters.term.value);
            this.handleCloseModal();
        }
    }

    handleOnChangeInput(event) {
        this.updateSearchTermValue(event.target.value)
    }

    updateSearchTermValue(value) {
        this.setState({
            filters: {
                term: {
                    value: value
                }
            }
        });
    }

    render() {
        const { exchangeIndexesFetched } = this.props;
        if (exchangeIndexesFetched){
            const modalContent = this.buildModalContent();
            const filtersBlock = this.buildFiltersBlock();
            const customPrimaryButton = (
                <OKButton typeButton="submit"
                    onClick={(event) => {
                    this.handleFiltersSubmit(event);
                }}>
                    <FormattedText value="broker-indexValuesFiltersApply" />
                </OKButton>
            );
            return (
                <section className="broker-main-stocks-result-list-content-filters">
                    <OKModal
                        content={modalContent}
                        footerType="navigation"
                        isOpen={this.state.modalOpen}
                        shouldCloseOnOverlayClick={false}
                        onCloseCallback={this.handleCloseModal}
                        onSecondaryButtonClick={this.handleCloseModal}
                        primaryButtonCustom={customPrimaryButton}
                        secondaryButtonText="broker-indexValuesFiltersCancel"
                        title="broker-indexValuesFiltersTitle"
                    />
                    {filtersBlock}
                </section>
            )
        }
        return null;
    }
}

BrokerMainStocksResultListContentFilters.propTypes = {
    filters: PropTypes.object.isRequired,
    activateTermFilter: PropTypes.func.isRequired,
    exchangeIndexesFetched: PropTypes.bool.isRequired,
    clearFilters: PropTypes.func.isRequired
};

module.exports = BrokerMainStocksResultListContentFilters;
